import { render } from "./thankyourejectdiy.vue?vue&type=template&id=e6500572&scoped=true"
import script from "./thankyourejectdiy.vue?vue&type=script&lang=js"
export * from "./thankyourejectdiy.vue?vue&type=script&lang=js"

import "./thankyourejectdiy.vue?vue&type=style&index=0&id=e6500572&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6500572"]])

export default __exports__